import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import request from '@/utils/request'

// 业务页面组件映射（按菜单 path 对应）
const modules = import.meta.glob('@/views/**/*.vue')
// 打印一次 glob 键，便于排查
console.log('[router] glob keys:', Object.keys(modules))

const Layout = () => import('@/layout/index.vue')

const routes = [
  { path: '/login', component: () => import('@/views/login/index.vue'), meta: { public: true } },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: '/dashboard',
    children: []
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

function findComponent(path) {
  // 菜单路径形如 /goods/list，文件名为 PascalCase：/src/views/goods/List.vue
  const segs = path.split('/').filter(Boolean)
  const last = segs[segs.length - 1]
  const pascal = last.charAt(0).toUpperCase() + last.slice(1)
  const dir = segs.slice(0, -1).join('/')
  const base = '/src/views' + (dir ? '/' + dir : '')
  const candidates = [
    base + '/' + pascal + '.vue',
    base + '/' + pascal + '/index.vue',
    '/src/views' + path + '.vue',
    '/src/views' + path + '/index.vue'
  ]
  for (const k of candidates) {
    if (modules[k]) {
      console.log('[router] map', path, '->', k)
      return modules[k]
    }
  }
  console.warn('[router] no component for', path, 'candidates', candidates)
  return () => import('@/views/dashboard/index.vue')
}

// 根据菜单树生成动态路由
export function generateRoutes(menus) {
  const result = []
  const walk = (list) => {
    ;(list || []).forEach((m) => {
      if (m.type === 2 && m.path) {
        result.push({
          path: m.path,
          component: findComponent(m.path),
          meta: { title: m.name }
        })
      }
      if (m.children && m.children.length) walk(m.children)
    })
  }
  walk(menus)
  return result
}

let routesInstalled = false
let redirectCount = 0

export function resetDynamicRouter() {
  routesInstalled = false
  redirectCount = 0
}

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (to.meta.public) {
    redirectCount = 0
    if (auth.isLoggedIn && to.path === '/login') return '/dashboard'
    return true
  }
  if (!auth.isLoggedIn) {
    redirectCount = 0
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  if (!routesInstalled) {
    if (redirectCount > 3) {
      // 防死循环
      auth.logoutLocal()
      return '/login'
    }
    redirectCount++
    try {
      const res = await request.get('/admin/auth/info')
      if (res.code === 0) {
        auth.setInfo(res.data)
        const dynamic = generateRoutes(res.data.menus)
        dynamic.forEach((r) => router.addRoute('layout', r))
        routesInstalled = true
        console.log('[router] dynamic routes added:', dynamic.map((d) => d.path))
        return { path: to.fullPath, replace: true }
      }
      auth.logoutLocal()
      return '/login'
    } catch (e) {
      console.error('[router] info fetch failed:', e)
      auth.logoutLocal()
      return '/login'
    }
  }
  redirectCount = 0
  // 路由已就绪但当前路径无任何匹配（如越权访问 /system/role，seller 菜单未注册该路由），
  // 重定向到工作台，避免主内容区空白。
  if (to.matched.length === 0) return '/dashboard'
  return true
})

export default router
